module.exports = __webpack_public_path__ + "static/media/study_files_icon.27e8eac1.svg";